import { type Enum } from '@webapp/infrastructure/types/Enum'

// Extended in future stories: RESULTS, UNSUPPORTED_QUERY, EMPTY, ERROR
export const ContentStates = {
  RECENTS: 'recents',
  LOADING: 'loading',
} as const

export type ContentStateEnum = Enum<typeof ContentStates>
